var _defs, _path, _line, _path2, _line2, _circle, _path3, _line3, _line4, _path4, _circle2, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepCheckout({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".step-checkout-1{fill:none;stroke:#58595b;stroke-linecap:round;stroke-miterlimit:10;stroke-width:0.75px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "step-checkout-1",
    d: "M18.58,27.56,15,24a3.28,3.28,0,0,1,0-4.65L20.23,14"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "step-checkout-1",
    x1: 40.61,
    y1: 14.53,
    x2: 30.93,
    y2: 24.21
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "step-checkout-1",
    d: "M25,9.26l5.49-5.49a3.3,3.3,0,0,1,4.65,0l9,9.05a3.3,3.3,0,0,1,0,4.65L28.66,33A3.28,3.28,0,0,1,24,33l-1-1"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "step-checkout-1",
    x1: 22.81,
    y1: 17.6,
    x2: 19.5,
    y2: 20.92
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "step-checkout-1",
    cx: 33.06,
    cy: 10.69,
    r: 2.37
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "step-checkout-1",
    d: "M13.28,35.35a4.7,4.7,0,0,1,.13-2.72c1.06-2.82,3.18-4.81,5.93-5.07a4.74,4.74,0,0,1,1.25.11"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "step-checkout-1",
    x1: 13.17,
    y1: 35.46,
    x2: 4.85,
    y2: 43.78
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "step-checkout-1",
    x1: 20.78,
    y1: 41.66,
    x2: 19.06,
    y2: 43.38
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "step-checkout-1",
    d: "M20.71,27.73l3.86-3.68a2.22,2.22,0,0,1,3.07.16h0a2,2,0,0,1,.06,2.88l-5.76,5.66"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "step-checkout-1",
    cx: 22.7,
    cy: 11.56,
    r: 0.44
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "step-checkout-1",
    d: "M20.91,41.58c4.37-1.36,10.81-2.2,12-9.87a13.72,13.72,0,0,0,.45-3.38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepCheckout);
export default __webpack_public_path__ + "static/media/step-checkout.107d7818.svg";
export { ForwardRef as ReactComponent };